import { Map } from 'immutable';

/**
 * Checks if the number of each railcard is at least as many as were applied to the reorderable
 */
export const matchRailcards = (reorderable, fare) => {
    const fareRailcardCounts = new Map(fare.getRailcardCounts());
    const reorderableRailcardCounts = reorderable.getRailcardCounts();

    return reorderable.getAllRailcards().count() === fare.getAllRailcards().count()
           && reorderableRailcardCounts.every((qty, code) => fareRailcardCounts.get(code, 0) >= qty);
};



// WEBPACK FOOTER //
// ./src/helpers/Railcards.js